import moment from 'moment'

type CreditCardChargeItem = {
  chargedAt: string
  status: string
  description: string
  statusDetail?: string
}

function mapperStatus(status: string) {
  switch (status) {
    case 'authorized':
      return 'Autorizado'
    case 'captured':
      return 'Capturado'
    case 'unathorized':
      return 'Não autorizado'
    case 'refunded':
      return 'Estornado'
    // Tentativa barrada pelo nosso limite de segurança antes de chegar ao banco
    // (muitas tentativas seguidas com o mesmo cartão, titular ou documento).
    case 'blocked':
      return 'Bloqueada'
    default:
      return 'Não identificado'
  }
}

export type CreditCardCharge = CreditCardChargeItem[]

const creditCardChargesMapper = (creditCardCharges: CreditCardCharge) => {
  return creditCardCharges.map((item) => ({
    chargedAt: moment(item?.chargedAt).format('DD/MM/YYYY HH:mm:ss'),
    status: mapperStatus(item.status),
    description: item?.description,
    statusDetail: item?.statusDetail ?? '—'
  }))
}

export default creditCardChargesMapper
